import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import Template from 'components/topics/news/DetailPageId'
import { Post, PropsPosts } from 'interfaces/posts'
import { fetchAllPosts, fetchPosts, fetchPost, fetchEventPosts } from 'lib/wp'
import { getTopicsOgImage, getTopicsCanonicalUrl } from 'lib/url'

const newsId: React.FC<Post> = ({ post, prevPost, nextPost, categoryName, articleHtml, activeEvents }) => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  })

  return (
    <>
      <HeadMeta
        keyword={'最新情報 プレスリリース ニュース イベント セミナー'}
        image={getTopicsOgImage(post.thumbnail_img)}
        url={getTopicsCanonicalUrl(post.id, post.categories, 'news')}
        title={`${post.title.rendered} | ニュース | Aitria（アイトリア）`}
        description={post.title.rendered}
      />
      <Template
        post={post}
        prevPost={prevPost}
        nextPost={nextPost}
        categoryName={categoryName}
        articleHtml={articleHtml}
        activeEvents={activeEvents}
      />
    </>
  )
}

export async function getStaticPaths(): Promise<{ paths: string[]; fallback: boolean }> {
  const posts = await fetchPosts(2)
  const paths = posts.map((post) => `/news/${post.id}`)
  return {
    paths,
    fallback: false,
  }
}

export async function getStaticProps({ params }): Promise<PropsPosts> {
  const [post, posts, eventPosts] = await Promise.all([fetchPost(params.id), fetchAllPosts(), fetchEventPosts()])
  const currentIndex = posts.findIndex((p) => p.id === parseInt(params.id))
  const prevPost = (() => {
    for (let i = currentIndex - 1; i >= 0; i--) {
      if (posts[i].categories.includes(2)) {
        return posts[i]
      }
    }
    return null
  })()
  const nextPost = (() => {
    for (let i = currentIndex + 1; i < posts.length; i++) {
      if (posts[i].categories.includes(2)) {
        return posts[i]
      }
    }
    return null
  })()

  const currentDate = new Date().toISOString()
  let activeEvents = eventPosts
    .filter((post) => post.end_date && new Date(post.end_date).toISOString() >= currentDate)
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, 5)
  // サムネイル画像URLを変換
  activeEvents = activeEvents.map((event) => {
    const updatedThumbnail = event.thumbnail_img
      ?.split('https://cms-admin.i3design.jp/wp-content/uploads')
      .join('/images/wp')
    return {
      ...event,
      thumbnail_img: updatedThumbnail,
    }
  })

  const categoryName = 'news'
  const articleHtml = post.content.rendered.split('https://cms-admin.i3design.jp/wp-content/uploads').join('/images/wp')

  return {
    props: {
      post,
      prevPost,
      nextPost,
      categoryName,
      articleHtml,
      activeEvents,
    },
  }
}

export default newsId
